<template>
  <div>
    <OrderEdit :data="data"></OrderEdit>
  </div>
</template>


<script scoped>
  import {db, fb} from '../firebase'
  import OrderEdit from '../components/OrderEdit';

  export default {
    name: 'UpdateOrder',
    components: {
      OrderEdit
    },
    data () {
      return {
        data: {
          mode: 'updateOrder',

          /* 注文の情報 */
          name: '',
          address: null,
          latitude: 0,
          longitude: 0,
          destinationName: '',
          clientName: '',
          selected_driver_id: null,

          /* Input Form */ 
          searchAddressInput: '',

          isLoading: false,
          company: null
        },
        order: null,
      }
    },
    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },
    },
    methods: {
      setInitialValues(){
        this.data.latitude = this.order.destination_latitude
        this.data.longitude = this.order.destination_longitude
        this.data.destinationName = this.order.destination_name
        this.data.address = this.order.destination_address
        this.data.searchAddressInput = this.order.destination_address
        this.data.clientName = this.order.client
        this.data.name = this.order.name
        this.data.selected_driver_id = this.order.driver_id
      },
      getOrder () {
        var _this = this
        this.$bind('order', db.collection('companies').doc(this.companyId).collection('orders').doc(this.$route.params.id)).then(order => {
          _this.setInitialValues()
        })
      },
      async submitOrder() {
        try {
          this.data.isLoading = true

          await db.collection("companies").doc(this.data.company.id).collection('orders').doc(this.order.id).update({
            client: this.data.clientName,
            status: "preparing",
            driver_id: this.data.selected_driver_id,
            destination_name: this.data.destinationName,
            destination_address: this.data.address,
            destination_latitude: this.data.latitude,
            destination_longitude: this.data.longitude,
            createdAt: fb.firestore.Timestamp.fromDate(new Date()), //https://stackoverflow.com/a/47969509/1709287
            name: this.data.name,
          })

          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 500) // resolve
          })
          this.$router.replace({ name: 'Home'})
        }catch(error){
          console.error("Error adding document: ", error);
          this.data.isLoading = false
        }
      },
      async deleteOrder() {
        try {
          this.data.isLoading = true
          await db.collection("companies").doc(this.data.company.id).collection('orders').doc(this.order.id).delete()
          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 500) // resolve
          })
          this.$router.replace({ name: 'Home'})
        }catch(error){
          console.error("Error adding document: ", error);
          this.data.isLoading = false
        }
      },
    },
    mounted ()  {
      this.getOrder()
    },

  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/UpdateOrder.vue